import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IErrorDialogComponent } from '@app/shared/models/dialog/error-dialog';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent {
  public title = '';
  public description = '';
  public closeButtonText = '';
  public actionButtonText: string | undefined = '';

  constructor(@Inject(MAT_DIALOG_DATA) private data: IErrorDialogComponent, private dialogRef: MatDialogRef<ErrorDialogComponent>) {
    this.title = this.data.title;
    this.description = this.data.description;
    this.closeButtonText = this.data.buttonText;
    this.actionButtonText = this.data.uploadButtonText;
  }

  public close(): void {
    this.dialogRef.close(true);
  }

  public confirm(): void {
    this.dialogRef.close(false);
  }
}
